import db from '@/dexie';

const database = {
  async setSettings(accessToken) {
    await db.session.put({id: 1, accessToken});
    return 1;
  },
  async getSettings() {
    return db.session.get(1);
  },
  async deleteSettings() {
    return db.session.clear();
  },
  async putAttachment(attachment) {
    const _a = {...attachment};
    _a.id = Date.now().toString();
    await db.attachments.put(_a);
    return _a;
  },
  async getAttachments() {
    return db.attachments.toArray();
  },
  async getAttachment(id) {
    return db.attachments.get(id);
  },
  async deleteAttachment(id) {
    return db.attachments.delete(id);
  },
  async itemCount() {
    const counts = await Promise.all([db.attachments.count()]);
    return counts.reduce((a, b) => a + b, 0);
  },
};

export default database;
const databaseEnabledPromise = new Promise((resolve, reject) => {
  const db = window.indexedDB.open('strategia');
  db.onerror = function () {
    console.log('database not enabled');
    resolve(false);
  };

  db.onsuccess = function () {
    console.log('database enabled');
    resolve(true);
  };
});

export {databaseEnabledPromise};
